<template>
  <br/>
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="per-page" class="form-label me-2 mt-2">Per page</label>
      <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
        <option :value="10">10</option>
        <option :value="20">20</option>
        <option :value="50">50</option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="type" class="form-label me-2 mt-2">Type</label>
      <select id="type" class="form-control" v-model="selectedType" @change="changeType(selectedType)">
        <option value="discord">Discord</option>
        <option value="telegram">Telegram</option>
      </select>
    </div>
  </div>
  <div class="table-responsive">
    <div class="alert alert-success" role="alert" v-if="success">
      {{success}}
    </div>
    <div class="alert alert-danger" role="alert" v-if="errorConfirm">
      {{errorConfirm}}
    </div>
    <table class="table">
      <thead>
      <tr>
        <th scope="col"># ID</th>
        <th scope="col">Name of connected service</th>
        <th scope="col">Creator name</th>
        <th scope="col">Creator slug</th>
        <th scope="col">Type</th>
        <th scope="col">Created at</th>
        <th scope="col">Connected users</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="integrations.length > 0" v-for="integration in integrations">
        <th scope="row">{{integration.id}}</th>
        <td>{{integration.name}}</td>
        <td>{{integration.channel.name}}</td>
        <td>{{integration.channel.slug}}</td>
        <td>{{integration.type}}</td>
        <td>{{integration.created_at}}</td>
        <td>{{integration.connected_users_count}}</td>
      </tr>
      <tr v-else-if="loading">
        <td colspan="7" class="text-center"><font-awesome-icon icon="fa-solid fa-sync" spin/></td>
      </tr>
      <tr v-else>
        <td colspan="7" class="text-center">No integrations</td>
      </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
      <div>
        <div class="p-2">
          <p>Total integrations: {{ totalRecords }}</p>
        </div>
      </div>
      <div>
        <div class="p-2">
          <nav v-if="totalPages >= 1" aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
              </li>
              <li class="page-item" :class="{active: 1 === currentPage}">
                <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage - 1 > 1">
                <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage !== 1"  :class="{active: currentPage}">
                <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
              </li>
              <li class="page-item" v-if="currentPage + 1 <= totalPages">
                <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 <= totalPages">
                <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 < totalPages">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
                <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
              </li>
              <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import _debounce from "lodash/debounce";

export default {
  data() {
    return {
      loading: true,
      disableExport: false,
      integrations: [],
      selectedType: 'discord',
      errorConfirm: '',
      success: '',
      keyword: '',
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      perPage: 20,
      disableConfirm: false,
      disableDeny: false
    }
  },

  mounted() {
    this.status = '';
    this.success = '';
    this.fetchChannelIntegrations(this.currentPage, this.perPage, this.selectedType);
  },

  methods: {


    debounceFetchChannelIntegrations: _debounce(function (page, perPage, type) {
      this.loading = true;
        const params = {};
        if (page !== undefined && page !== null) params.page = page;
        if (perPage !== undefined && perPage !== null) params.per_page = perPage;
        if (type !== undefined && type !== null) params.type = type;
      axios.get(`/admin/integration-channels` ,{params})
          .then(response => {
            this.integrations = response.data.data;
            this.totalPages = response.data.last_page;
            this.totalRecords = response.data.total;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            this.errorConfirm = error.response?.data?.message || 'Error occurred while fetching integrations';
            console.log(error);
          });
    }, 500),


    fetchChannelIntegrations(page, perPage, type) {
      this.debounceFetchChannelIntegrations(page, perPage, type);
    },
    changeType(selectedType) {
      this.selectedType = selectedType;
      this.currentPage = 1;
      this.fetchChannelIntegrations(this.currentPage, this.perPage, this.selectedType);
    },
    perPageFilter(perPage) {
      this.perPage = perPage;
      this.currentPage = 1;
      this.fetchChannelIntegrations(this.currentPage, this.perPage, this.selectedType);
    },
    paginate(page) {
      this.currentPage = page;
      this.fetchChannelIntegrations(this.currentPage, this.perPage, this.selectedType);
    },
  }
}
</script>
